angular.module("acl.visualizer.model.accessControl", [
  "acl.common.config",
  "acl.common.dataRequester",
  "acl.visualizer.model.model",
  "acl.visualizer.promiseCache",
]);
